// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/b3/dialogs/dialogs.less
// module id = 503
// module chunks = 0